var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImageFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:#231F20;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 4.9,
    className: "st2",
    width: 3.7,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 7.9,
    className: "st2",
    width: 3.7,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 10.9,
    className: "st2",
    width: 3.7,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 13.9,
    className: "st2",
    width: 3.7,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 16.9,
    className: "st2",
    width: 3.7,
    height: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24,2.4h-9.9l0-2.2h-1.3L0,2.4v18.9l13,2.4h1.1l0-2.6H24V2.4z M9.9,16.3H8L6.6,13L5.5,16l-2-0.1l2.1-4 L3.8,7.7h1.8l1.1,2.8L8,7.4h1.9l-2.1,4.6L9.9,16.3z M23.2,20.5h-9.1l0-1.7h2.2v-1.9h-2.2l0-1.1h2.2v-1.9h-2.2l0-1.1h2.2v-1.9h-2.2 l0-1.1h2.2V7.9h-2.2l0-1.1h2.2V4.9h-2.2l0-1.7h9.1V20.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "16.6,11.5 12.9,14 8.4,8.6 2,14 2,20.1 22,20.1 22,16.4 22,14  "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 6.1,
    r: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,22.2H0V1.8h24V22.2z M1.2,21h21.5V3H1.2V21z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImageFill);
export default __webpack_public_path__ + "static/media/icon_image_fill.ebff44926f22ddd959fd0a7771a6d966.svg";
export { ForwardRef as ReactComponent };